import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "data-table-td text-slate-500"
};
const _hoisted_7 = {
  class: "data-table-td"
};
const _hoisted_8 = {
  class: "data-table-td"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_12 = {
  class: "text-xs text-slate-500"
};
const _hoisted_13 = {
  key: 1,
  class: "text-xs text-slate-400"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = {
  class: "data-table-td text-slate-500"
};
const _hoisted_16 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_17 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "p-6"
};
const _hoisted_21 = {
  key: 0,
  class: "animate-pulse space-y-4"
};
const _hoisted_22 = {
  key: 1,
  class: "space-y-5"
};
const _hoisted_23 = {
  class: "flex items-center gap-2 flex-wrap"
};
const _hoisted_24 = {
  class: "grid grid-cols-2 gap-4 text-sm"
};
const _hoisted_25 = {
  class: "text-slate-900 mt-0.5"
};
const _hoisted_26 = {
  class: "text-slate-900 mt-0.5"
};
const _hoisted_27 = {
  class: "col-span-2"
};
const _hoisted_28 = {
  class: "text-slate-900 mt-0.5"
};
const _hoisted_29 = {
  class: "bg-slate-50 rounded-lg p-4 text-sm text-slate-800 leading-relaxed whitespace-pre-wrap"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "grid grid-cols-3 gap-3"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["src", "alt"];
const _hoisted_34 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_35 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_36 = ["disabled"];
const _hoisted_37 = ["disabled"];
const _hoisted_38 = {
  key: 0,
  class: "w-4 h-4 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
};
const _hoisted_39 = {
  class: "relative"
};
const _hoisted_40 = ["src"];
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
import { usePagination } from '@/composables/usePagination';
import { useSearch } from '@/composables/useSearch';
import { getFeedbackList, getFeedbackDetail, processFeedback } from '@/api/feedback';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';

// 数据

export default {
  __name: 'FeedbackManagement',
  setup(__props) {
    const loading = ref(false);
    const feedbackList = ref([]);

    // 分页
    const {
      pagination,
      goToPage,
      setPageSize,
      updatePagination,
      getPaginationParams
    } = usePagination();

    // 搜索
    const {
      searchForm,
      handleSearch: triggerSearch,
      resetSearch,
      getSearchParams
    } = useSearch({
      initialForm: {
        type: '',
        status: ''
      },
      onSearch: fetchData
    });

    // 反馈类型映射
    const typeMap = {
      1: {
        label: '功能建议',
        color: 'bg-blue-50 text-blue-700 ring-blue-600/20'
      },
      2: {
        label: '系统问题',
        color: 'bg-red-50 text-red-700 ring-red-600/20'
      },
      3: {
        label: '内容错误',
        color: 'bg-amber-50 text-amber-700 ring-amber-600/20'
      },
      4: {
        label: '其他',
        color: 'bg-slate-50 text-slate-700 ring-slate-600/20'
      }
    };

    // status map
    const statusMap = {
      0: {
        label: '待处理',
        color: 'bg-amber-50 text-amber-700 ring-amber-600/20'
      },
      1: {
        label: '已处理',
        color: 'bg-green-50 text-green-700 ring-green-600/20'
      }
    };

    // 类型筛选选项
    const typeOptions = [{
      label: '全部类型',
      value: ''
    }, {
      label: '功能建议',
      value: 1
    }, {
      label: '系统问题',
      value: 2
    }, {
      label: '内容错误',
      value: 3
    }, {
      label: '其他',
      value: 4
    }];

    // 状态筛选选项
    const statusOptions = [{
      label: '全部状态',
      value: ''
    }, {
      label: '待处理',
      value: 0
    }, {
      label: '已处理',
      value: 1
    }];

    // 详情窗口
    const showDetailModal = ref(false);
    const detailLoading = ref(false);
    const currentFeedback = ref(null);

    // 处理确认窗口
    const showProcessModal = ref(false);
    const processTarget = ref(null);
    const processLoading = ref(false);

    // 图片预览
    const showImagePreview = ref(false);
    const previewImageUrl = ref('');

    // 获取数据
    async function fetchData() {
      loading.value = true;
      try {
        const params = {
          ...getSearchParams(),
          ...getPaginationParams()
        };
        const data = await getFeedbackList(params);
        feedbackList.value = data.records || [];
        updatePagination(data);
      } catch (error) {
        ElMessage.error('加载反馈列表失败');
        console.error('加载反馈列表失败:', error);
      } finally {
        loading.value = false;
      }
    }

    // 筛选变化
    const handleFilterChange = () => {
      pagination.current = 1;
      fetchData();
    };

    // 换页
    const changePage = page => {
      goToPage(page);
      fetchData();
    };

    // 切换每页条数
    const changePageSize = size => {
      setPageSize(size);
      fetchData();
    };

    // 查看详情
    const handleViewDetail = async item => {
      showDetailModal.value = true;
      detailLoading.value = true;
      try {
        const detail = await getFeedbackDetail(item.id);
        currentFeedback.value = detail;
      } catch (error) {
        ElMessage.error('加载反馈详情失败');
        console.error('加载反馈详情失败:', error);
        currentFeedback.value = item;
      } finally {
        detailLoading.value = false;
      }
    };

    // 关闭详情窗口
    const closeDetailModal = () => {
      showDetailModal.value = false;
      currentFeedback.value = null;
    };

    // 打开处理确认窗口
    const handleProcess = item => {
      processTarget.value = item;
      showProcessModal.value = true;
    };

    // 确认处理
    const confirmProcess = async () => {
      if (!processTarget.value) return;
      processLoading.value = true;
      try {
        const targetId = processTarget.value.id;
        await processFeedback(targetId);
        ElMessage.success('已标记为已处理');
        showProcessModal.value = false;
        // 如果详情窗口打开，同步更新状态
        if (currentFeedback.value?.id === targetId) {
          currentFeedback.value.status = 1;
        }
        processTarget.value = null;
        fetchData();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        console.error('处理反馈失败:', error);
      } finally {
        processLoading.value = false;
      }
    };

    // 从详情窗口触发处理
    const handleProcessFromDetail = () => {
      if (currentFeedback.value) {
        handleProcess(currentFeedback.value);
      }
    };

    // 解析图片列表
    const parseImages = images => {
      if (!images) return [];
      return images.split(',').map(url => url.trim()).filter(Boolean);
    };

    // 预览图片
    const openImagePreview = url => {
      previewImageUrl.value = url;
      showImagePreview.value = true;
    };

    // 关闭图片预览
    const closeImagePreview = () => {
      showImagePreview.value = false;
      previewImageUrl.value = '';
    };

    // 格式化时间
    const formatDateTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN');
    };

    // 截断文本
    const truncateText = (text, maxLength = 60) => {
      if (!text) return '-';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "意见反馈管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "查看和处理用户提交的意见反馈")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = (...args) => _unref(triggerSearch) && _unref(triggerSearch)(...args)),
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = (...args) => _unref(resetSearch) && _unref(resetSearch)(...args)),
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(searchForm).type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchForm).type = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(searchForm).status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left w-16"
        }, "ID"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "反馈内容"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "图片"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left w-44"
        }, "提交时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[7] || (_cache[7] = [_createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-10 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 w-16 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-3/4 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-4 w-8 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-5 w-14 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex gap-1 justify-center"
          }, [_createElementVNode("div", {
            class: "h-7 w-7 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-7 w-7 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : feedbackList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [...(_cache[8] || (_cache[8] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "w-8 h-8 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        })])]), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无反馈数据"), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "用户提交反馈后将会在此展示")])], -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(feedbackList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_6, _toDisplayString(item.id), 1), _createElementVNode("td", _hoisted_7, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset", typeMap[item.type]?.color || 'bg-slate-50 text-slate-600 ring-slate-500/20'])
          }, _toDisplayString(typeMap[item.type]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_8, [_createElementVNode("span", {
            class: "cursor-pointer hover:text-primary-600 transition-colors",
            onClick: $event => handleViewDetail(item)
          }, _toDisplayString(truncateText(item.content)), 9, _hoisted_9)]), _createElementVNode("td", _hoisted_10, [parseImages(item.images).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[9] || (_cache[9] = _createElementVNode("svg", {
            class: "w-4 h-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(parseImages(item.images).length) + "张", 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))]), _createElementVNode("td", _hoisted_14, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset", statusMap[item.status]?.color || 'bg-slate-50 text-slate-600 ring-slate-500/20'])
          }, _toDisplayString(statusMap[item.status]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_15, _toDisplayString(formatDateTime(item.createTime)), 1), _createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("button", {
            onClick: $event => handleViewDetail(item),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_18), item.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleProcess(item),
            class: "table-action-button is-success",
            title: "标记已处理",
            "aria-label": "标记已处理"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_19)), [[_directive_permission, 'app:feedback:edit']]) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), _unref(pagination).total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: _unref(pagination),
          "page-sizes": [10, 20, 50],
          onPageChange: changePage,
          onSizeChange: changePageSize
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "2xl",
          scrollable: false,
          onClose: closeDetailModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
          }, [_cache[14] || (_cache[14] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "反馈详情", -1)), _createElementVNode("button", {
            onClick: closeDetailModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_20, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[15] || (_cache[15] = [_createElementVNode("div", {
            class: "flex gap-3"
          }, [_createElementVNode("div", {
            class: "h-5 w-16 bg-slate-200 rounded-full"
          }), _createElementVNode("div", {
            class: "h-5 w-14 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("div", {
            class: "h-4 w-1/3 bg-slate-200 rounded"
          }, null, -1), _createElementVNode("div", {
            class: "space-y-2"
          }, [_createElementVNode("div", {
            class: "h-4 w-full bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-4 w-3/4 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-4 w-1/2 bg-slate-200 rounded"
          })], -1)]))])) : currentFeedback.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset", typeMap[currentFeedback.value.type]?.color])
          }, _toDisplayString(typeMap[currentFeedback.value.type]?.label || '未知类型'), 3), _createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ring-1 ring-inset", statusMap[currentFeedback.value.status]?.color])
          }, _toDisplayString(statusMap[currentFeedback.value.status]?.label || '未知状态'), 3)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "反馈ID", -1)), _createElementVNode("p", _hoisted_25, _toDisplayString(currentFeedback.value.id), 1)]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "用户ID", -1)), _createElementVNode("p", _hoisted_26, _toDisplayString(currentFeedback.value.userId), 1)]), _createElementVNode("div", _hoisted_27, [_cache[18] || (_cache[18] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "提交时间", -1)), _createElementVNode("p", _hoisted_28, _toDisplayString(formatDateTime(currentFeedback.value.createTime)), 1)])]), _cache[21] || (_cache[21] = _createElementVNode("div", {
            class: "border-t border-slate-100"
          }, null, -1)), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-2"
          }, "反馈内容", -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(currentFeedback.value.content || '无内容'), 1)]), parseImages(currentFeedback.value.images).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_cache[20] || (_cache[20] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-2"
          }, "图片预览", -1)), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseImages(currentFeedback.value.images), (img, idx) => {
            return _openBlock(), _createElementBlock("div", {
              key: idx,
              class: "aspect-square rounded-lg overflow-hidden border border-slate-200 cursor-pointer hover:ring-2 hover:ring-primary-500 transition-all group",
              onClick: $event => openImagePreview(img)
            }, [_createElementVNode("img", {
              src: img,
              alt: '反馈图片' + (idx + 1),
              class: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
            }, null, 8, _hoisted_33)], 8, _hoisted_32);
          }), 128))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("button", {
            onClick: closeDetailModal,
            class: "btn-secondary"
          }, " 关闭 "), currentFeedback.value?.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: handleProcessFromDetail,
            class: "btn-primary"
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1), _createTextVNode(" 标记已处理 ", -1)]))])), [[_directive_permission, 'app:feedback:edit']]) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showProcessModal.value,
          size: "sm",
          "panel-class": "p-6 mx-4",
          onClose: _cache[5] || (_cache[5] = $event => showProcessModal.value = false)
        }, {
          default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("div", {
            class: "flex items-center gap-4 mb-4"
          }, [_createElementVNode("div", {
            class: "w-12 h-12 rounded-full flex items-center justify-center bg-green-100 flex-shrink-0"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-green-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "确认处理"), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "确定要将此反馈标记为已处理吗？")])], -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => showProcessModal.value = false),
            disabled: processLoading.value,
            class: "btn-secondary"
          }, " 取消 ", 8, _hoisted_36), _createElementVNode("button", {
            onClick: confirmProcess,
            disabled: processLoading.value,
            class: "btn-primary"
          }, [processLoading.value ? (_openBlock(), _createElementBlock("svg", _hoisted_38, [...(_cache[23] || (_cache[23] = [_createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1), _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }, null, -1)]))])) : _createCommentVNode("", true), _cache[24] || (_cache[24] = _createTextVNode(" 确认 ", -1))], 8, _hoisted_37)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showImagePreview.value,
          size: "none",
          "panel-class": "max-w-[90vw]",
          "z-index": 60,
          onClose: closeImagePreview
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
            src: previewImageUrl.value,
            alt: "图片预览",
            class: "max-w-full max-h-[85vh] rounded-lg shadow-2xl object-contain"
          }, null, 8, _hoisted_40), _createElementVNode("button", {
            onClick: closeImagePreview,
            class: "absolute -top-2 -right-2 z-10 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center text-slate-500 hover:text-slate-700 transition-colors cursor-pointer"
          }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};